import React from 'react';
import { connect } from 'react-redux';
import { ShowSiteLoading } from '../SiteLoadingIndicator';

const mapStateToProps = ({ activeExercise }) => ({
   loading: activeExercise?.exerciseDocument == null,
});

const ExerciseLoading = connect(mapStateToProps)(({ loading }) =>
   loading ? <ShowSiteLoading /> : null
);

export { ExerciseLoading };
